import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { DatePicker, Form, Input, Select, Checkbox } from 'antd';

import CRUDE_City from '../../../objects/City/crude'
import REDUX_City from '../../../objects/City/reducer'
import REDUX_TipiMeropriyatii from '../../../objects/TipiMeropriyatii/reducer'
import REDUX_UrovenMeropriyatiya from '../../../objects/UrovenMeropriyatiya/reducer'
import { errorCatch, GET, useFormObserverContext } from 'fennec-ui';

import dayjs from 'dayjs'
import 'dayjs/locale/ru'
import locale from 'antd/es/date-picker/locale/ru_RU';
import EmojiTextArea from '../../../common/EmojiTextArea';
dayjs.locale('ru');


const { Option } = Select;


export default function IzmenitMeropriyatiyaAd(props) {
    const { auth, object, form, sourceKey } = props;
    const dispatch = useDispatch();

    const city = useSelector(REDUX_City.selector.array);
    const tipMeropriyatiya = useSelector(REDUX_TipiMeropriyatii.selector.array);
    const urovenMeropriyatiya = useSelector(REDUX_UrovenMeropriyatiya.selector.array);
    
    let orgKey = undefined;
    if (object?.organizatorFederatsiyaID) {
        orgKey = "fed";
    } else if (object?.organizatorRegionalnoeOtdelenieID) {
        orgKey = "reg";
    } else if (object?.organizatorMeropriyatiyaID) {
        orgKey = "org";
    } else if (object?.organizatorShkolaID) {
        orgKey = "school";
    }
    
    // const tekushchieStatusiMeropriyatii = useSelector(REDUX_TekushchieStatusiMeropriyatii.selector.array);
    useEffect(() => {
        form.resetFields();
        CRUDE_City.read(auth, (data) => {
            if (data.length > 0) {
                dispatch(REDUX_City.actions.setArray(data));
            }
        }, 'model', 's-id=ASC');
        // console.log(object)
        GET(auth, '/api/tipimeropriyatii/' + orgKey,
            ({data}) => {
                dispatch(REDUX_TipiMeropriyatii.actions.setArray(data));
            },
            (err)=>errorCatch(err));
        GET(auth, '/api/urovenmeropriyatiya/' + orgKey,
            ({data}) => {
                dispatch(REDUX_UrovenMeropriyatiya.actions.setArray(data));
            },
            (err)=>errorCatch(err));
        // CRUDE_TekushchieStatusiMeropriyatii.read(auth, (data) => {
        //     if (data.length > 0) {
        //         dispatch(REDUX_TekushchieStatusiMeropriyatii.actions.setArray(data));
        //     }
        // }, 'model', 's-id=ASC');
    }, []);
    const cityOptions = city.map((i) => <Option key={i.ID} value={i.ID}>{i.name}</Option>);
    const tipMeropriyatiyaOptions = tipMeropriyatiya.map((i) => <Option key={i.ID} value={i.ID}>{i.opisanie}</Option>);
    const urovenMeropriyatiyaOptions = urovenMeropriyatiya.map((i) => <Option key={i.ID} value={i.ID}>{i.opisanie}</Option>);
    // const tekushchieStatusiMeropriyatiiOptions = tekushchieStatusiMeropriyatii.map((i) => <Option key={i.ID} value={i.ID}>{i.opisanie}</Option>);

    // const columns = () => {
    //     var c = [];
    //     c.push({
    //         title: 'Танцевальная дисциплина',
    //         render: (text, record) => {
    //             return (
    //                 <div>
    //                     {record.tantsevalnayaDistsiplina.nazvanie}
    //                 </div>
    //             );
    //         },
    //         key: 'tantsevalnayaDistsiplina',
    //     });
    //     c.push({
    //         title: 'Категория участников',
    //         render: (text, record) => {
    //             return (
    //                 <div>
    //                     {record.kategoriyaUchastnikov.nazvanie}
    //                 </div>
    //             );
    //         },
    //         key: 'kategoriyaUchastnikov',
    //     });
    //     return c;
    // };
    const [isChangedForm, isChangedField, onValuesChange] = useFormObserverContext()
    return (
        <>
            <Form
                form={form}
                onValuesChange={onValuesChange}
                onFinish={props.submit}
                labelAlign={"left"}
                layout={"vertical"}
                initialValues={{
                    ...object,
                    nachaloRegistratsii: (object) ? dayjs(object.nachaloRegistratsii) : undefined,
                    nachaloAdministrativnogoKontrolya: (object) ? dayjs(object.nachaloAdministrativnogoKontrolya) : undefined,
                    okonchanieAdministrativnogoKontrolya: (object) ? dayjs(object.okonchanieAdministrativnogoKontrolya) : undefined,
                    nachaloSorevnovaniya: (object) ? dayjs(object.nachaloSorevnovaniya) : undefined,
                    okonchanieSorevnovaniya: (object) ? dayjs(object.okonchanieSorevnovaniya) : undefined,
                    priceText: (object) ? object.priceText : undefined,
                    shapkaUsloviiVozvrata: (object) ? object.shapkaUsloviiVozvrata : undefined,
                    podvalUsloviiVozvrata: (object) ? object.podvalUsloviiVozvrata : undefined,
                    reklama: (object) ? object.reklama : undefined,
                    reklamaPopup: (object) ? object.reklamaPopup : undefined,
                }}
            >
                <Form.Item label="Реклама в приложении Jack and Jill"
                    name="reklama"
                    rules={[{ required: false, message: 'Пожалуйста, укажите текст рекламы!' }]}
                >
                    <EmojiTextArea rows={8} />
                </Form.Item>
                <Form.Item label="Всплывающая реклама в приложении Jack and Jill"
                    name="reklamaPopup"
                    rules={[{ required: false, message: 'Пожалуйста, укажите текст всплывающей рекламы!' }]}
                >
                    <EmojiTextArea rows={8} />
                </Form.Item>
            </Form>
        </>
    );
}
